import { render, staticRenderFns } from "./SentimentPlatForm.vue?vue&type=template&id=75a4b952&scoped=true&"
import script from "./SentimentPlatForm.vue?vue&type=script&lang=js&"
export * from "./SentimentPlatForm.vue?vue&type=script&lang=js&"
import style0 from "./SentimentPlatForm.vue?vue&type=style&index=0&id=75a4b952&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a4b952",
  null
  
)

export default component.exports